import { OrderExecutionTermsOrderType } from 'api/types/entity/order/orderExecutionTermsEntity';
import { number, object, string, selectSchema } from 'libs/form';
import { TFunc } from 'libs/i18n';

import { OrderFormType } from '../type';

import { getFinancialInstrumentSchema } from './common/financialInstrumentSchema';

export const getSecuritiesPurchaseSchema = (t: TFunc) =>
  object({
    executionTerms: object({
      orderType: selectSchema(Object.values(OrderExecutionTermsOrderType))
        .required()
        .default(null),
      yield: string().nullable(),
      additionalNotes: string().nullable().max(200),
      operationPurpose: string().nullable().max(200),
    }),

    financialInstrument: getFinancialInstrumentSchema(t),

    transactionVolume: object({
      quantity: number().required().min(1),
      nominalQuantity: string(),
      unitPrice: string().when((_, schema, opt) => {
        const context = opt.context as OrderFormType;
        if (
          context.executionTerms?.orderType?.value ===
          OrderExecutionTermsOrderType.Limit
        ) {
          return schema.required();
        }
        return schema;
      }),
      currency: object({
        value: string().required(),
        label: string().required(),
      })
        .required()
        .default(null),
      transactionAmount: string().when((_, schema, opt) => {
        const context = opt.context as OrderFormType;
        if (
          context.executionTerms?.orderType?.value ===
          OrderExecutionTermsOrderType.Limit
        ) {
          return schema.required();
        }
        return schema;
      }),
    }),
  });
